import { render } from "./Fumetto.vue?vue&type=template&id=39e89b12"
import script from "./Fumetto.vue?vue&type=script&lang=js"
export * from "./Fumetto.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__